import { updateSummaryDashboardActive } from '@apis'
import { useMutation } from '@tanstack/react-query'

import useAdminDashboardQueryInvalidation from './useAdminDashboardQueryInvalidation'

type UpdateSummaryDashboardActiveVariables = {
  dashboardId: string
  isActive: boolean
}

const useUpdateSummaryDashboardActive = () => {
  const { invalidateAdminDashboardList, invalidateAdminDashboardDetail } = useAdminDashboardQueryInvalidation()

  return useMutation({
    mutationFn: async ({ dashboardId, isActive }: UpdateSummaryDashboardActiveVariables) => {
      const response = await updateSummaryDashboardActive(dashboardId, isActive)

      if (response.codeHTTP !== 200) {
        throw new Error('Failed to save dashboard status.')
      }

      await invalidateAdminDashboardList()
      await invalidateAdminDashboardDetail(dashboardId)

      return response
    },
  })
}

export default useUpdateSummaryDashboardActive
